var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.656 0 3.439 1.33H1.33A1.334 1.334 0 0 0 0 2.661v7.982a1.334 1.334 0 0 0 1.33 1.33h10.643a1.334 1.334 0 0 0 1.33-1.33V2.661a1.334 1.334 0 0 0-1.33-1.33H9.865L8.647 0zm2 9.978a3.326 3.326 0 1 1 1.27-.252 3.3 3.3 0 0 1-1.274.252z"
  })));
};
export default SvgCamera;